import React, { useState } from 'react'
import SanityLink from '@/lib/SanityLink'
import * as css from './LinkGroup.module.css'
import clsx from 'clsx'

/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */

const LinkGroup = ({ label, items }) => {
	const [$open, set$open] = useState(false)

	return (
		<details open={$open}
			className={clsx(css.root, 'relative open:bg-orange-light <md:open:mb-2 h-full transition-colors')}
			onMouseEnter={() => set$open(true)}
			onMouseLeave={() => set$open(false)}
		>
			<summary className="grid place-content-center py-4 px-6 md:h-full <md:py-2">
				{label}
			</summary>

			<ul className={css.contents}>
				{items?.map((item, key) => (
					<li key={key}>
						<SanityLink {...item} />
					</li>
				))}
			</ul>
		</details>
	)
}

export default LinkGroup
